import React, { useEffect, useRef, useState, useContext } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Controller, useFormContext } from 'react-hook-form';
import { COLORS } from '../../../../utils/Application_Constants';

const useStyles = makeStyles((theme) => ({
    tabLabel: {
        display: 'flex',
        gap: 8,
        alignItems: 'center',
    },
    textFieldRoot: {
        marginBottom: 0,
        '& .MuiOutlinedInput-input': {
            padding: '4px !important',
            outline: 'none !important',
            border: 'none !important',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            outline: 'none !important',
            border: 'none !important',
        },
    },
    tabLabelInput: {
        cursor: 'pointer',
        fontSize: 14,
    },
}));

const ExpenseTabLabel = (props) => {
    const {
        handleRemoveTab,
        index,
        isActive,
        setValue,
        tab,
        mode,
        isViewOnly,
        originalPrimaryExpense,
        isAnyExpensePosted,
    } = props;
    const classes = useStyles();
    const [isEditing, setIsEditing] = useState(false);
    const ref = useRef();
    const { errors, watch } = useFormContext();
    const expenseEntries = watch('expenseEntries');
    const [hideDelete, setHideDelete] = useState(false);

    const handleBlur = () => {
        setIsEditing(false);
    };

    const handleEdit = () => {
        ref.current.focus();
        ref.current.select();
        setIsEditing((prevState) => !prevState);
    };

    useEffect(() => {
        if (mode === 'pending-cc' && expenseEntries[index].id > 0) {
            setHideDelete(true);
        }
    }, []);

    return (
        <div className={classes.tabLabel}>
            <Controller
                defaultValue={mode === 'vault' ? 'Vault Charge' : tab.label}
                name={`expenseEntries[${index}].label`}
                rules={{
                    required: 'Tabs must be named',
                }}
                render={({ onChange, value }) => (
                    <TextField
                        onClick={() => setValue(index)}
                        onChange={onChange}
                        onBlur={handleBlur}
                        classes={{ root: classes.textFieldRoot }}
                        value={value}
                        InputProps={{
                            readOnly: !isEditing,
                        }}
                        inputProps={{ className: classes.tabLabelInput }}
                        inputRef={ref}
                        required
                        error={Boolean(errors.expenseEntries?.[index]?.label)}
                        helperText={errors.expenseEntries?.[index]?.label?.message}
                        sx={{
                            '& .MuiOutlinedInput-input': {
                                color: !errors.expenseEntries?.[index]
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
            {isActive && !isViewOnly && (
                <EditIcon fontSize="small" color="primary" onClick={handleEdit} />
            )}
            {index !== 0 &&
                expenseEntries[index].status !== 'Posted' &&
                !hideDelete &&
                !isViewOnly &&
                !(mode !== 'pending-cc' && isAnyExpensePosted) && (
                    <CloseIcon fontSize="small" onClick={() => handleRemoveTab(index)} />
                )}
        </div>
    );
};

export default ExpenseTabLabel;
